// React
import { ChangeEvent } from 'react';

// Interfaces
import { IFormUploadSingleFile } from './interfaces'

// Antd
import { Button } from 'antd'

// i18n
import { useTranslation } from 'react-i18next'

// Constant
import { FILE_DOCUMENT_EXTENSIONS, FILE_IMAGE_EXTENSIONS, FILE_MIME_FORMATTED } from 'constant/file.constant'

// Custom Hook
import { useUploader } from 'hooks'

// Merge
const mergedExtensions = [...FILE_DOCUMENT_EXTENSIONS, ...FILE_IMAGE_EXTENSIONS]

const FormUploadSingleFile = ({ fileName, onChange, error, acceptedExtensions }: IFormUploadSingleFile) => {
  // Hook
  const { t } = useTranslation()
  const { uploader_Input, uploader_onClickSingleFile, uploader_singleFileInputRef, uploader_onChangeSingleFile } = useUploader({
    acceptedExtensions: acceptedExtensions || mergedExtensions,
  })
  const mapAcceptedExtensions = (): any => {
    const mapMimes: string[] = []
    const mimes = FILE_MIME_FORMATTED.map(file => file.mimes)
    mimes.forEach(mime => {
      for (const [index, value] of Object.entries(mime)) {
        if (
          (!acceptedExtensions ? mergedExtensions : acceptedExtensions)?.some(acceptedExtension =>
            acceptedExtension?.includes(value),
          )
        )
          mapMimes.push(index)
      }
    })

    return (mapMimes.length !== 0 ? mapMimes : []).toString().split(',').join(', ').toString()
  }

  return (
    <>
      {/* Plain HTML Input File */}
      <input
        type="file"
        style={{ display: 'none' }}
        ref={uploader_singleFileInputRef}
        onChange={(event: ChangeEvent<HTMLInputElement>) => uploader_onChangeSingleFile(event, file => onChange(file))}
      />

      <Button
        type="primary"
        className={`custom-button common-upload ${error ? 'error' : ''}`}
        ghost
        onClick={uploader_onClickSingleFile}
      >
        {fileName ? fileName : t('myDocument.formPlaceholder.document')}
      </Button>

      {/* Description */}
      <p className="font-12 font-weight-400 mt-2">
        {t('app.title.documentFormat')} All Files
      </p>
    </>
  )
}

export { FormUploadSingleFile }
